var swiper = new Swiper(".mySwiper", {
    slidesPerView: 1,
    slideActiveClass: "panel-swiper-slide-active",
    centeredSlides: true,
    loop: true,
    speed: 1000,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2
      }
    },
});


// var swiper = new Swiper(".autoScrollSwiper", {
//     slidesPerView: 1,
//     slideActiveClass: "autoscroll-swiper-slide-active",
//     centeredSlides: true,
//     spaceBetween: 20,
//     loop: true,
//     speed: 1000,
//     pagination: {
//       el: ".swiper-pagination",
//       clickable: true,
//       type: "progressbar",
//     },
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//     breakpoints: {
//       768: {
//         slidesPerView: 5
//       }
//     },
// });

var swiper = new Swiper(".autoScrollSwiper", {
      // effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 1.5,
      loop: true,
      spaceBetween: 40,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
      speed: 4000,
      // coverflowEffect: {
      //   rotate: 0,
      //   stretch: 0,
      //   depth: 0,
      //   scale: 0.9,
      //   modifier: 1,
      //   slideShadows: false
      // },
      // pagination: {
      //   el: ".swiper-pagination",
      //   clickable: true,
      //   type: "progressbar",
      // },
      breakpoints: {
      768: {
          slidesPerView: 5
        }
      },
    });